import { useLocation, useNavigate } from "react-router-dom";
import WithTableView from "../../components/withTableView/withTableView";
import Pagination from "../../components/pagination/pagination";
import { useEffect, useState } from "react";
import { deleteByIdApi, getAllApi } from "../../api";
import toast from "react-hot-toast";
import Modal from "../../components/modal/modal";

const Products = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inFocus, setInFocus] = useState("");
  const [modal, setModal] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    getAllApi("products")
      .then((response) => {
        console.log(response.data);
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setData([]);
        console.log(error);
        toast.error(
          error?.response?.status === 404
            ? "Products Not Found"
            : "Something went wrong while fetching products."
        );
        setLoading(false);
      });
  };

  const handleDelete = () => {
    setModal(false);
    const promise = new Promise((resolve, reject) => {
      deleteByIdApi("products", inFocus)
        .then((res) => {
          setInFocus("");
          resolve(true);
        })
        .catch((err) => {
          reject();
        });
    });

    toast
      .promise(
        promise,
        {
          loading: "Deleting...",
          success: "Deleted Successfully.",
          error: "Error when deleting the entry.",
        },
        { success: { duration: 2000 }, error: { duration: 2000 } }
      )
      .then(() => {
        getData();
      });
  };

  return (
    <>
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => {
          setModal(false);
          setInFocus("");
        }}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <WithTableView
        heading="Products"
        head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
        body_keys={["title", "action:delete"]}
        body={data}
        show_btn_1={true}
        btn1Text="Add"
        btn1Type="filled"
        isIcon={true}
        iconType="add"
        onRowClick={(id) => {
          navigate(`/products/${id._id}`);
        }}
        onClickHandler={() => navigate("/products/add")}
        loading={loading}
        onActionClick={(id, val) => {
          setInFocus(val);
          setModal(true);
        }}
        customElement={<></>}
      />
    </>
  );
};

export default Products;
